// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2-vwuNG-7ZJkkI4yR9_u2C","columnsContainer":"_TVXS3RG-zOp2MB4-WnRo","column":"_2Xpt7Av-4Og_49m5dwzP2q"};